import LegalDocument from "@/components/LegalDocument";
import LegalComingSoon from "@/components/LegalComingSoon";
import { PRIVACY } from "@/lib/legal/privacyContent";
import { LEGAL_FACTS_READY } from "@/lib/legalConfig";

export default function Privacy() {
  if (!LEGAL_FACTS_READY) return <LegalComingSoon title="Privacy Policy" path="/privacy" testId="privacy-coming-soon" />;
  return (
    <LegalDocument
      doc={PRIVACY}
      path="/privacy"
      description="How RateCurrent handles your information: we never save the bill file, what we keep, who our service providers are, and how to ask for access or deletion."
      testId="privacy-page"
    />
  );
}
